<template>
  <div class="advanced">
    <p class="headline headline-medium">Advanced options</p>

    <template v-if="intent.type === 'intent'">
      <div class="field-wrapper">
        <div class="switch-wrapper">
          <input :id="`${intent.id}-noBeh`" hidden type="checkbox" v-model="noBeh" />
          <label class="switch" :for="`${intent.id}-noBeh`"></label>
          <span class="switch__label">Disable behavior Tracking</span>
        </div>
      </div>

      <div class="field-wrapper">
        <select-box
          @resize="updateSize"
          @selected="setStrength"
          label="Behavior Strength"
          :options="strengthsDropdown"
          :disabled="strengthDisabled"
        />
      </div>
    </template>

    <div class="field-wrapper">
      <p class="label label-large">Score Threshold</p>
      <div class="text-field">
        <input class="text-field__input" type="text" v-model="threshold" />
      </div>

      <p class="label-medium-emphasis">
        This intent tag will apply if the visitor has {{ threshold }} score or more in the
        {{ intent.name }} intent.
      </p>
    </div>

    <div class="field-wrapper">
      <div class="switch-wrapper">
        <input :id="`${intent.id}-noPn`" hidden type="checkbox" v-model="noPn" />
        <label class="switch" :for="`${intent.id}-noPn`"></label>
        <span class="switch__label">Disable for personalization</span>
      </div>

      <p class="label-medium-emphasis">
        Visitor's score in {{ intent.name }} can contribute to selection of this content when personalizing.
      </p>
    </div>

    <div class="field-wrapper" :class="{ 'field-disabled': overrideDisabled }">
      <div class="switch-wrapper">
        <input :id="`${intent.id}-override`" hidden type="checkbox" v-model="override" />
        <label class="switch" :for="`${intent.id}-override`"></label>
        <span class="switch__label">Override personalization</span>
      </div>

      <p class="label-medium-emphasis">Personalization will use normal rules.</p>
    </div>
  </div>
</template>

<script>
import SelectBox from './SelectBox.vue';
import { intentTagStrength } from '../utils';

export default {
  components: {
    SelectBox,
  },

  props: {
    intent: { type: Object, required: true },
  },

  data() {
    return {
      noBeh: this.intent.noBeh,
      noPn: this.intent.noPn,
      override: this.intent.override,
      str: this.intent.signals[0].str,
      threshold: this.intent.threshold || 0,
      strengthDisabled: false,
      overrideDisabled: false,
    };
  },

  computed: {
    strengthsDropdown() {
      const result = [];

      for (const strength in intentTagStrength) {
        if (strength !== 'Antimatter') {
          result.push({
            value: intentTagStrength[strength],
            label: `${strength} (${intentTagStrength[strength]}%)`,
            selected: intentTagStrength[strength] === this.intent.signals[0].str ? true : false,
          });
        }
      }

      return result;
    },
  },

  watch: {
    noBeh(val) {
      this.strengthDisabled = val;
      this.updateStore();
    },

    noPn(val) {
      this.overrideDisabled = val;
      this.updateStore();
    },

    threshold() {
      this.updateStore();
    },

    override() {
      this.updateStore();
    },
  },

  methods: {
    updateSize() {
      this.$emit('resize');
    },

    setStrength(data) {
      this.str = data;
      this.updateStore();
    },

    updateStore() {
      const dataToSend = {
        noBeh: this.noBeh,
        noPn: this.noPn,
        override: this.override,
        threshold: Number(this.threshold),
        str: this.str,
      };

      this.$store.commit('saveAdvancedOptions', {
        data: dataToSend,
        intentId: this.intent.id,
      });

      this.$emit('save');
    },
  },
};
</script>

<style scoped>
.advanced {
  flex-basis: 100%;
  width: 100%;
  margin: 1rem auto;

  background-image: linear-gradient(180deg, rgba(175, 197, 233, 0.2), rgba(125, 149, 227, 0.2));

  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 1rem;
}

.headline {
  margin: 0 0 2rem 0;
}

.field-wrapper {
  margin: 0 0 2rem 0;
  max-width: 300px;
}

.field-wrapper:last-child {
  margin: 0;
}

.label {
  margin: 0 0 0.5rem 0;
}

.label-medium-emphasis {
  margin: 0.7rem 0 0 0;
}

.field-disabled {
  opacity: 0.3;
  pointer-events: none;
  cursor: not-allowed;
}
</style>
